// ** Third Party Components
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

// ** Custom Components
import ListItemAllowPrivacy from "./ListItemAllowPrivacy";
import { TogglePreferences } from "./TogglePreferences";

// #####################################################

const AllowedPrivacy = ({ state, dispatch }) => {
	const { t } = useTranslation(["common", "userpanel"]);

	const user = useSelector((state) => state.globalUser);
	const preferences = useSelector(
		(state) => state.userpanelSettings?.preferences,
	);

	// #####################################################

	return (
		<ul>
			<ListItemAllowPrivacy
				action="Friends"
				state={state}
				dispatch={dispatch}
			/>
			<ListItemAllowPrivacy
				action="Followers"
				state={state}
				dispatch={dispatch}
			/>
			<TogglePreferences
				tooltipText={
					user?.status_vip < 5 &&
					t("userpanel:settings.preferences.vip.tooltips.showMyAge")
				}
				toggled={state.verifyVipShowMyAge.status}
				disabled={!preferences?.verifyVipShowMyAge?.enabled}
				dispatchAction={() =>
					dispatch({
						type: "SET",
						field: "verifyVipShowMyAge",
						special: true,
					})
				}
				text={t("userpanel:settings.preferences.vip.showMyAge")}
				noMarginBottom
			/>
		</ul>
	);
};

// #####################################################

export default AllowedPrivacy;

// #####################################################
